import * as types from "../actions/types";


const initialState = {
    invitationscount: null,
    videomessagesNotBeenSeencount: null,
    contentgroups: null,
    secondarycontentgroups: null,
    users: null,
    secondaryusers: null,
    invitations: null,
    usergroups: null,
    secondaryusergroups: null,
    zones: null,
    secondaryzones: null
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CONTENTGROUPS_COMPLETED:
            return Object.assign({}, state, {
                contentgroups: action.payload
            });
        case types.GET_CONTENTGROUPS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondarycontentgroups: action.payload
            });
        case types.GET_USERS_COMPLETED:
            return Object.assign({}, state, {
                users: action.payload
            });
        case types.GET_USERS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondaryusers: action.payload
            });
        case types.GET_INVITATIONS_COMPLETED:
            return Object.assign({}, state, {
                invitations: action.payload
            });
        case types.GET_USERGROUPS_COMPLETED:
            return Object.assign({}, state, {
                usergroups: action.payload
            });
        case types.GET_ZONES_COMPLETED:
            return Object.assign({}, state, {
                zones: action.payload
            });
        case types.GET_CALLCATEGORIES_COMPLETED:
            return Object.assign({}, state, {
                callcategories: action.payload
            });
        case types.GET_ZONES_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondaryzones: action.payload
            });
        case types.GET_USERGROUPS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondaryusergroups: action.payload
            });
        case types.GET_INVITATIONSCOUNT_COMPLETED:
            return Object.assign({}, state, {
                invitationscount: action.payload
            });
        case types.GET_VIDEOMESSAGESNOTBEENSEENCOUNT_COMPLETED:
            return Object.assign({}, state, {
                videomessagesNotBeenSeencount: action.payload
            });
        case types.GET_PAGINATIONTYPE_WAITINGLIST_COMPLETED:
            return Object.assign({}, state, {
                paginationtypewaitinglist: action.payload
            });
        case types.GET_PAGINATIONTYPE_WEBCALL_COMPLETED:
            return Object.assign({}, state, {
                paginationtypewebcall: action.payload
            });
        case types.GET_PAGINATIONTYPE_CALLOG_COMPLETED:
            return Object.assign({}, state, {
                paginationtypecalllogs: action.payload
            });

        default:
            return state;
    }
};
